import { render } from "./compositeLayout.vue?vue&type=template&id=19ce6cf4&scoped=true"
import script from "./compositeLayout.vue?vue&type=script&lang=js"
export * from "./compositeLayout.vue?vue&type=script&lang=js"

import "./compositeLayout.vue?vue&type=style&index=0&id=19ce6cf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19ce6cf4"

export default script